import { render, staticRenderFns } from "./AsAdresseeList.vue?vue&type=template&id=61e71098&"
import script from "./AsAdresseeList.vue?vue&type=script&lang=js&"
export * from "./AsAdresseeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports